import React, { useState, useEffect, useCallback } from "react";
import Header from "../../commons/Header/Header";
import Sidebar from "../../commons/Sidebar/Sidebar";
import viewImage from "../../assets/images/icons/view.svg";
import TeamImg from "../../assets/images/login-bg.jpg";
import editImage from "../../assets/images/icons/edit-2.svg";
import DeleteIcon from "../../assets/images/icons/delete-w.svg";
import Cuisine from "../../assets/images/img.webp";
import { Link, useNavigate } from "react-router-dom";
import { handleApiCall } from "../../apis";
import { endpoints } from "../../utils/endpoints";
import { toast } from "react-toastify";
import { Button } from "react-bootstrap";
import { UI_CONSTANTS } from "../../utils/constants";
import TablePagination from "../../commons/Pagination/TablePagination";

function Alergies() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const [data, setData] = useState([]);
  const [cms, setCms] = useState({ type: "publish" });
  const [search, setSearch] = useState("");
  const [page, setPage] = useState(1);
  const [limit] = useState(10);
  const [totalPages, setTotalPages] = useState(1);

  const getList = useCallback(async () => {
    setLoading(true);
    try {
      const query = new URLSearchParams({
        page: String(page),
        limit: String(limit),
        ...(search && { name: search }),
      }).toString();

      const response = await handleApiCall("get", `${endpoints.allergiesList}?${query}`);
      if (response?.data?.code === UI_CONSTANTS.API_CODES.SUCCESS) {
        const payload = response?.data?.data;
        const list = Array.isArray(payload)
          ? payload
          : Array.isArray(payload?.data)
            ? payload.data
            : [];
        const pagination = Array.isArray(payload)
          ? response?.data?.pagination
          : payload?.pagination;

        setData(list);
        setTotalPages(pagination?.totalPages || 1);
      }
    } catch (error) {
      console.error("Error fetching allergies:", error);
      setError(true);
    } finally {
      setLoading(false);
    }
  }, [page, limit, search]);

  useEffect(() => {
    getList();
  }, [getList]);

  // Reset page to 1 when search changes
  useEffect(() => {
    setPage(1);
  }, [search]);

  const block = async (status, id) => {
    try {
      const response = await handleApiCall("patch", `${endpoints.allergiesStatusUpdate}/${id}`, {
        status,
      });
      if (response?.data?.code === UI_CONSTANTS.API_CODES.SUCCESS) {
        toast.success(response?.data?.message || UI_CONSTANTS.TOAST_MESSAGES.SUCCESS.STATUS_UPDATED);
        getList();
      }
    } catch (error) {
      // Network errors are already handled by handleApiCall
    }
  };

  const deleteAllergy = async (id) => {
    if (window.confirm(UI_CONSTANTS.CONFIRMATION_MESSAGES.DELETE_ALLERGY)) {
      try {
        const response = await handleApiCall("delete", `${endpoints.allergiesDelete}/${id}`);
        if (response?.data?.code === UI_CONSTANTS.API_CODES.SUCCESS) {
          toast.success(UI_CONSTANTS.TOAST_MESSAGES.SUCCESS.ALLERGY_DELETED);
          getList();
        }
      } catch (error) {
        // Network errors are already handled by handleApiCall
      }
    }
  };

  return (
    <div className="container-scroller">
      <Header />
      <div className="container-fluid page-body-wrapper">
        <Sidebar />
        <div className="main-panel">
          <div className="content-wrapper">
            <div className="heading mb-3 d-flex align-items-center">
              <h3 className="text-default weight-400 my-0">{UI_CONSTANTS.PAGE_TITLES.ALLERGIES}</h3>
            </div>
            <div className="mb-4 px-0 py-2">
              <div className="card-heading d-flex align-items-center mb-3 pb-2">
                <div className="d-flex align-items-center col-md-12 px-0">
                  <form className="col-md-3 px-0">
                    <div className="form-group my-0">
                      <input
                        className="form-control search-icon left-icon border"
                        placeholder={UI_CONSTANTS.PLACEHOLDERS.SEARCH}
                        value={search}
                        onChange={(e) => setSearch(e.target.value)}
                      />
                    </div>
                  </form>
                  <button onClick={() => navigate(UI_CONSTANTS.ROUTES.ADD_ALLERGY)} className="ml-auto btn btn-primary">
                    {UI_CONSTANTS.BUTTON_LABELS.ADD_NEW}
                  </button>
                </div>
              </div>
              <div className="col-md-12 tab-content row px-0 mx-0">
                <div className="table-responsive px-0">
                  <table className="table table-striped trim">
                    <thead>
                      <tr>
                        <th width="80" className="text-center">
                          {UI_CONSTANTS.TABLE_HEADERS.ID}
                        </th>
                        <th>{UI_CONSTANTS.TABLE_HEADERS.TITLE}</th>
                        <th>{UI_CONSTANTS.TABLE_HEADERS.INGREDIENTS}</th>
                        <th width="150px">{UI_CONSTANTS.TABLE_HEADERS.STATUS}</th>
                        <th width="100px">{UI_CONSTANTS.TABLE_HEADERS.ACTIONS}</th>
                      </tr>
                    </thead>
                    <tbody>
                      {loading ? (
                        <tr>
                          <td colSpan="5" className="text-center py-4">
                            <div className="spinner-border text-primary" role="status">
                              <span className="sr-only">{UI_CONSTANTS.BUTTON_LABELS.LOADING}</span>
                            </div>
                          </td>
                        </tr>
                      ) : data && data.length > 0 ? (
                        data.map((allergy, index) => (
                          <tr key={allergy._id}>
                            <td>{(page - 1) * limit + index + 1}</td>
                            <td className="text-center">{allergy.name}</td>
                            <td>
                              {allergy.ingredients && allergy.ingredients.length > 0 ? allergy.ingredients.map((ingredient) => ingredient.ingredient_name).join(", ") : "N/A"}
                            </td>
                            <td>
                              <label className="custom-control custom-switch p-1 ml-4 mb-0 mt-1" role="button">
                                <input
                                  type="checkbox"
                                  className="custom-control-input"
                                  checked={allergy.status === 1}
                                  onChange={() => block(allergy.status === 1 ? 0 : 1, allergy._id)}
                                />
                                <span className="custom-control-label custom-toggle" />
                              </label>
                            </td>
                            <td>
                              <button
                                onClick={() => {
                                  localStorage.setItem(UI_CONSTANTS.LOCAL_STORAGE_KEYS.SELECTED_ALLERGY, JSON.stringify(allergy));
                                  window.location.href = `${UI_CONSTANTS.ROUTES.EDIT_ALLERGY}/${allergy._id}`;
                                }}
                                className="btn btn-link p-0 mx-2"
                              >
                                <img src={editImage} alt={UI_CONSTANTS.BUTTON_LABELS.EDIT} className="mr-2" />
                              </button>
                              {/* <button
                                onClick={() => deleteAllergy(allergy._id)}
                                className="btn btn-link p-0 mx-2"
                              >
                                <img
                                  src={DeleteIcon}
                                  alt={UI_CONSTANTS.BUTTON_LABELS.DELETE}
                                  className="mr-2"
                                />
                              </button> */}
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="5" className="text-center py-4">
                            {UI_CONSTANTS.EMPTY_STATES.NO_DATA_FOUND}
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
              <TablePagination page={page} totalPages={totalPages} onPageChange={setPage} />

            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Alergies;
